var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'contrast' : _vm.$store.state.contrast},style:('font-size:' + _vm.$store.state.fontsize + 'px')},[(!_vm.isFormPage)?_c('navigation-bar'):_vm._e(),_c('main',[_c('router-view')],1),(!_vm.isFormPage)?_c('page-footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }